import React, { Component } from 'react';
import "./sub_topic.css";

export default class SubTopic extends Component {
  render() {
    return <div>Sub Topic</div>;
  }
}
